import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";
import { Control } from "react-hook-form";
import Button from "~/shared/ui/Fields/Button";
import Input from "~/shared/ui/Fields/Input";
import IconCheck from "~/components/Icons/icon-check";
import IconClose from "~/components/Icons/icon-close";
import s from "../StaffBonusColumnsTable.less";

export const getStaffBonusColumnsColumns = (
  t: TFunction,
  options: string[],
  control: Control,
  openRows: Record<string, boolean>,
  toggleRow: (rowId: string, state?: boolean) => void,
  handleSave: (dataObject: any) => void,
  handleCancel: (rowId: string) => void
): ColumnsType<any> =>
  options.map((option) => {
    const baseColumn = {
      title: t(`staffColumns.${option}`),
      dataIndex: option,
      key: option,
    };

    // Колонка description с инлайн редактированием
    if (option === "description") {
      return {
        ...baseColumn,
        render: (_: any, record: any) => {
          const isOpen = !!openRows[record.id];

          return isOpen ? (
            <div className={s.wrapperForm}>
              <Input
                name="description"
                control={control}
                defaultValue={record.description}
              />
              <Button
                txtBtn=""
                customClassName={s.editBtn}
                onlyIcon
                onClick={() => handleSave(record)}
              >
                <IconCheck fill={"#495A64"} />
              </Button>
              <Button
                txtBtn=""
                customClassName={s.editBtn}
                onlyIcon
                onClick={() => handleCancel(record.id)}
              >
                <IconClose fill={"#495A64"} />
              </Button>
            </div>
          ) : (
            record.description
          );
        },
      };
    }

    return {
      ...baseColumn,
      render: (value: any) => <span>{value}</span>,
    };
  });
